import React from 'react';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import * as Icons from 'assets';

import { Action } from 'state';
import Section from 'types/Section';
import FieldPreview from './FieldPreview';
import MeasurementType from 'types/MeasurementType';

const SectionHeader = styled.div`
  display: flex;
`;

const StyledSubtitle = styled(Typography)`
  font-weight: bold;
`;

const StyledIcon = styled.img`
  margin: 0 0 0.1rem 0.5rem;
`;

interface SectionPreviewProps {
  section: Section;
  dispatch: (action: Action) => void;
}

const SectionPreview: React.FC<SectionPreviewProps> = ({ section, dispatch }) => {
  const rootFields = section.exam_fields.filter((f) => !f.parent_uuid);

  const sectionIcon = React.useMemo(() => {
    switch (section.measurement_type) {
      case MeasurementType.ELLIPTICAL:
        return Icons.elliptical;
      case MeasurementType.VTI:
        return Icons.vti;
      default:
        return Icons.linear;
    }
  }, [section.measurement_type]);

  return (
    <>
      <SectionHeader>
        <StyledSubtitle variant="subtitle1">{section.label}</StyledSubtitle>
        {section.measurement_type && <StyledIcon src={sectionIcon} />}
      </SectionHeader>
      {rootFields.map((field) => (
        <FieldPreview key={field.uuid} field={field} section={section} dispatch={dispatch} />
      ))}
    </>
  );
};

export default SectionPreview;
